import React from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { Redirect, useHistory } from 'react-router-dom';
import {
  withStyles,
  MuiThemeProvider,
  createTheme,
} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import NavigateNext from '@material-ui/icons/NavigateNext';
import { useTranslation } from 'react-i18next';
import { object } from 'prop-types';
import headerBackground from '../Images/header-background.png';
import Footer from '../components/Footer';
import { getData } from '../../../state/reducers/ApplicationReducer';
import { getPaymentRecord } from '../../../state/reducers/PaymentReducer';
import ApplicationActions from '../../../state/actions/ApplicationActions';

let styles = (theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
    },
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(4),
    minWidth: 350,
    maxWidth: 1000,
  },
  button: {
    marginTop: theme.spacing(2),
  },
  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  titleStyle: {
    color: '#ffffff',
    fontWeight: 'bold',
  },
  subTitle: {
    color: '#4CAF50',
    fontWeight: 'bold',
  },
  warningText: {
    color: '#4CAF50',
    marginTop: theme.spacing(2),
  },
  idText: {
    marginTop: theme.spacing(4),
    color: '#000000',
  },
  emailText: {
    marginTop: theme.spacing(4),
    color: '#000000',
  },
  infoText: {
    display: 'flex',
    alignItems: 'center',
  },
  buttonApplications: {
    fontWeight: 'bold',
    color: '#F9F9F9',
    backgroundColor: '#357a38',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(1.1),
    paddingBottom: theme.spacing(1.1),
    fontSize: 18,
  },
  itemMidContainer: {
    marginTop: theme.spacing(10),
  },
});

let theme = createTheme({
  palette: {
    primary: {
      main: '#6fbf73',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#f50057',
      contrastText: '#ffffff',
    },
  },
  typography: {
    useNextVariants: true,
  },
});

let sectionStyle = {
  height: '345px',
  backgroundImage: `url(${headerBackground})`,
};

function PaymentInfo(props) {
  let { classes, application, isLAO, reset } = props;
  let { push } = useHistory();
  let { t } = useTranslation();
  if (!application.isMarkedForLocalPayment) {
    return <Redirect to={'/applications'} />;
  }
  let email = application.applicantEmail;
  return (
    <div>
      <Grid
        container
        alignItems="center"
        justifyContent="center"
        direction="row"
      >
        <Grid
          className={classes.headerContainer}
          style={sectionStyle}
          item
          xs={12}
        >
          <Typography
            className={classes.titleStyle}
            variant="h3"
            align="center"
            gutterBottom
          >
            {t('onlineServices')}
          </Typography>
        </Grid>
        <Grid className={classes.itemMidContainer}>
          <Paper className={classes.root} elevation={3}>
            <Typography
              className={classes.subTitle}
              align="center"
              variant="h4"
            >
              {t('paymentInfo.header')}
            </Typography>
            <Typography
              className={classes.warningText}
              align="center"
              variant="body2"
            >
              {t('applicationSubmitted')}
            </Typography>
            <Typography className={classes.idText} align="center">
              {t('paymentInfo.description')}
              <br />
              {t('paymentInfo.additional')}
            </Typography>
            <Typography className={classes.idText} align="center" variant="h6">
              {t('paymentInfo.appId')}
              {`${application.ian}`}
            </Typography>
            {isLAO && (
              <Typography
                className={classes.idText}
                align="center"
                variant="h6"
              >
                {t('shortcode')}
                {`${application.shortCode}`}
              </Typography>
            )}
            <Typography className={classes.emailText} align="center">
              {t('emailSentTo')}
              {email || 'your email address'}
              {t('withApplicationID')}
            </Typography>
          </Paper>
          <Grid container direction="row" justifyContent="space-between">
            <Typography className={classes.infoText} variant="subtitle1">
              {t('applicationTracked')}
            </Typography>
            <MuiThemeProvider theme={theme}>
              <Button
                variant="contained"
                color="primary"
                className={classes.buttonApplications}
                onClick={() => {
                  push('/applications');
                  reset();
                }}
              >
                {t('goToApplications')}
                <NavigateNext className={classes.rightIcon} />
              </Button>
            </MuiThemeProvider>
          </Grid>
        </Grid>
      </Grid>
      <Footer />
    </div>
  );
}

PaymentInfo.propTypes = {
  classes: object.isRequired,
};

const { clearCurrentApplication } = ApplicationActions;

export default compose(
  withStyles(styles),
  connect(
    (s) => ({
      paymentRecord: getPaymentRecord(s),
      application: getData(s),
    }),
    { reset: clearCurrentApplication }
  )
)(PaymentInfo);



// WEBPACK FOOTER //
// ./src/view/scenes/Payment/PaymentInfo.js